$(function() {
    'use strict';
    var trackingUtils = require('../modules/utils/tracking.utils');
    var formatDate = function(date) {
        return Odigeo.Utils.formatDate(date, 'd-mmm', true);
    };

    var parsePassengers = function(numPassengers, $item) {
        var textPassengers = '';
        var dataAttrName = 'data-' + (1 < numPassengers ? 'plural' : 'singular');
        if (0 < numPassengers) {
            textPassengers = numPassengers + ' ' + $item.attr(dataAttrName);
        }
        $item.toggleClass('hidden', 0 >= numPassengers);
        return textPassengers;
    };

    var getDataCity = function($city) {
        return _.reduce($city.data(), function(city, value, key) {
            city[Odigeo.Utils.stringToCamelCase(key)] = value;
            return city;
        }, {});
    };

    Odigeo.defineWidget('inspirational_manager', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            init: function() {
                this.on('set:requestParameters', function() {
                    this.fetchArrivalCities();
                });
            },

            url: function() {
                return Odigeo.Settings.getProperty('inspirationalServiceUrlFormatter')('arrivalCities') +
                    this.calculateQueryParams();
            },

            calculateQueryParams: function() {
                var params = {
                    departureIata: this.get('departureCity').iata,
                    departureDate: this.get('departureDate'),
                    arrivalDate: this.get('arrivalDate'),
                    sortByPrice: true,
                };
                var queryParams = '';
                _.map(params, function(value, key) {
                    if (_.isString(value) || _.isBoolean(value)) {
                        queryParams += ';' + key + '=' + value;
                    }
                });
                return queryParams;
            },

            setPassengers: function(passengers) {
                _.each(passengers, (value, key) => {
                    this.set(key, value);
                });
                this.trigger('change:passengers');
            },

            setSearchParams: function(searchParams) {
                var passengers = this.widget.extractPassengers(searchParams);
                this.setRequestParams(searchParams);
                this.setPassengers(passengers);
                this.transformSearchParams(searchParams);
                this.set('searchParams', _.omit(searchParams, 'rooms'));
            },

            setRequestParams: function(searchParams) {
                var departureCity = this.widget.extractDepartureCity(searchParams);
                var departureDate = this.widget.extractDepartureDate(searchParams);
                var arrivalDate = this.widget.extractArrivalDate(searchParams);
                this.set('departureDate', departureDate);
                this.set('arrivalDate', arrivalDate);
                this.set('departureCity', departureCity);
                this.trigger('set:requestParameters');
            },

            isLoaded: function() {
                return !!this.get('searchParams');
            },

            transformSearchParams: function(searchParams) {
                delete searchParams.isInspirationalSearch;
                searchParams.directFlightsOnly = false;
                searchParams.cabinClass = 'TOURIST';
                searchParams.collectionMethod = '';
                return searchParams;
            },

            setArrivalCity: function(city) {
                city.text = city.name = city.city;
                this.syncSearchParams({
                    city: city,
                });
                this.set('arrivalCity', city);
            },

            syncSearchParams: function(data) {
                var searchParams = this.get('searchParams');
                var firstSegment = this.widget.extractSegment(searchParams, 0);
                var lastSegment = this.widget.extractSegment(searchParams);
                var city = data.city;
                firstSegment.destination = _.extend({}, firstSegment.destination, city);
                if (!_.isUndefined(lastSegment)) {
                    lastSegment.departure = _.extend({}, lastSegment.departure, city);
                }
            },

            fetchArrivalCities: function() {
                var model = this;
                $.get(this.url())
                    .done(function(arrivalCities) {
                        model.set('arrivalCities', arrivalCities);
                        trackingUtils.trackEventWithCategory(
                            'inspirational',
                            'on_load_events',
                            'loaded_with_prices_' + model._numberOfCitiesWithPrice(arrivalCities)
                        );
                    });
            },

            _numberOfCitiesWithPrice: function(arrivalCities) {
                var numberOfCities = 0;
                _.each(arrivalCities, function(city) {
                    if (!_.isEmpty(city.price)) {
                        numberOfCities++;
                    }
                });
                return numberOfCities;
            },
        }),

        viewClass: Odigeo.View.extend({
            init: function() {
                var model = this.model;

                _.templateSettings = {
                    evaluate: /\{\{#([\s\S]+?)\}\}/g,
                    interpolate: /\{\{([^#][\s\S]+?)\}\}/g,
                };

                this.cacheDomSelectors();
                this.template = _.template(this.$cachedSelectors.arrivalCityTemplate.html());

                model.on('change:departureCity', _.bind(this.update, this, 'departureCity'));
                model.on('change:departureDate', _.bind(this.update, this, 'departureDate'));
                model.on('change:arrivalDate', _.bind(this.updateArrivalDate, this));
                model.on('change:passengers', _.bind(this.updatePassengers, this));
                model.on('change:arrivalCities', _.bind(this.update, this, 'arrivalCities'));
            },

            events: {
                'tap .inspirational_get_prices_button': 'searchButtonHandler',
            },

            searchButtonHandler: function(event) {
                var model = this.model;
                var city = getDataCity($(event.currentTarget));
                var searchParams = model.get('searchParams');

                model.setArrivalCity(city);
                this.widget.staticPageTrackingHandler(city.iata, city.price, city.position);
                Odigeo.trigger(this.widget.id + ':search', searchParams);
            },

            selectors: {
                departureCity: {
                    selector: '.departure_city_name',
                    parser: function(city) {
                        return city.name;
                    },
                },
                departureDate: {
                    selector: '.inspirational_departure_date',
                    parser: formatDate,
                },
                arrivalDate: {
                    selector: '.inspirational_arrival_date',
                    parser: formatDate,
                },
                numAdults: {
                    selector: '.inspirational_passengers_adults',
                    parser: parsePassengers,
                },
                numChildren: {
                    selector: '.inspirational_passengers_children',
                    parser: parsePassengers,
                },
                numInfants: {
                    selector: '.inspirational_passengers_infants',
                    parser: parsePassengers,
                },
                oneWayDate: {
                    selector: '.inspirational_date_one_way',
                },
                roundTripDate: {
                    selector: '.inspirational_date_round_trip',
                },
                arrivalCities: {
                    selector: '.inspirational_cities',
                    parser: function(arrivalCities) {
                        var arrivalCitiesHtml = this.template({
                            arrivalCities: arrivalCities,
                        });
                        return arrivalCitiesHtml;
                    },
                },
                arrivalCityTemplate: {
                    selector: '#inspirational_arrival_city_template',
                },
            },

            addDomSelectorsToCache: function() {
                _.each(this.selectors, (value, key) => {
                    this.addSelectorToCache(key, this.$widget.find(value.selector));
                });
            },

            update: function(attrName) {
                var attrValue = this.model.get(attrName);
                var parser = _.bind(this.selectors[attrName].parser, this);
                var $item = this.$cachedSelectors[attrName];
                var parsedValue = _.isFunction(parser) ? parser(attrValue, $item) : attrValue;

                this.$cachedSelectors[attrName].html(parsedValue);
            },

            updateArrivalDate: function() {
                var $cachedSelectors = this.$cachedSelectors;
                var arrivalDate = this.model.get('arrivalDate');
                var existArrivalDate = !_.isUndefined(arrivalDate);

                $cachedSelectors.oneWayDate.toggleClass('hidden', existArrivalDate);
                $cachedSelectors.roundTripDate.toggleClass('hidden', !existArrivalDate);
                this.update('arrivalDate');
            },

            updatePassengers: function() {
                _.each(['numAdults', 'numChildren', 'numInfants'], (numPassengers) => {
                    this.update(numPassengers);
                });
                this.$widget.find('.inspirational_passenger_type.last_child')
                    .removeClass('last_child');
                this.$widget.find('.inspirational_passenger_type:not(.hidden)')
                    .last()
                    .addClass('last_child');
            },
        }),

        staticPageTrackingHandler: function(cityIata, price, positionInList) {
            trackingUtils.trackEventWithCategory(
                'inspirational_page',
                'inspirational_pods',
                'inspire_me_' + cityIata + '_' + price + '_' + positionInList
            );
        },

        extractSegment: function(searchParams, index) {
            var searchSegments = searchParams.searchSegments;
            if (_.isUndefined(index)) {
                index = Math.max(searchSegments.length - 1, 1);
            }
            return searchSegments[index];
        },

        extractSegmentDate: function(searchParams, index) {
            var segment = this.extractSegment(searchParams, index);
            if (!_.isUndefined(segment)) {
                return segment.dateStr;
            }
        },

        extractDepartureDate: function(searchParams) {
            return this.extractSegmentDate(searchParams, 0);
        },

        extractArrivalDate: function(searchParams) {
            return this.extractSegmentDate(searchParams);
        },

        extractDepartureCity: function(searchParams) {
            return this.extractSegment(searchParams, 0).departure;
        },

        extractPassengers: function(searchParams) {
            var keys = ['numAdults', 'numChildren', 'numInfants'];
            return _.reduce(keys, function(passengers, key) {
                passengers[key] = searchParams[key];
                return passengers;
            }, {});
        },

        publicMethods: {
            // [alias]: [internal reference to method]
            setSearchParams: 'model.setSearchParams',
            isLoaded: 'model.isLoaded',
        },

        execute: function(func) {
            return Odigeo.Utils.executeInternalMethods(this, this.publicMethods, func, _.toArray(arguments).slice(1));
        },
    }));
});
